import { Link } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-12 text-slate-900 sm:px-6">
      <div className="w-full max-w-md text-center">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 text-slate-500">
          <FileQuestion className="h-7 w-7" aria-hidden="true" />
        </div>
        <p className="mt-6 text-sm font-semibold text-slate-500">Error 404</p>
        <h1 className="mt-1 text-2xl font-semibold tracking-tight text-slate-900">Página no encontrada</h1>
        <p className="mt-2 text-sm text-slate-600">
          La dirección que abriste no existe o ya no está disponible.
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center justify-center rounded-lg bg-[color:var(--action)] px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:opacity-90 dark:text-slate-950"
        >
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}
